import Component from "../../../../js/assets/component.js"

class TourContactInformation extends Component{
  constructor(selector) {
    // set root element
    super(selector)
  }

  // 他のコンポーネント(tour_detail_reserve)に依存している。期待するDOM要素が見つからなければなにもしない。
  tryCopyValue(from, to) {
    const inputFrom = $(from)
    const inputTo = $(to)

    if (inputFrom.length !== 0) {
      inputTo.val(inputFrom.val())
    }
  }

  copyDate() {
    this.tryCopyValue('#departure_date', '#tourContactInformation_departureDate')
  }

  copyAirNumber() {
    this.tryCopyValue('#air-number-adult', '#tourContactInformation_airNumberAdult')
    this.tryCopyValue('#air-number-child', '#tourContactInformation_airNumberChild')
    this.tryCopyValue('#air-number-infant', '#tourContactInformation_airNumberInfant')
  }

  copyRoomNumber() {
    this.tryCopyValue('#number-of-single-room', '#tourContactInformation_numberOfSingleRoom')
    this.tryCopyValue('#number-of-twin-room', '#tourContactInformation_numberOfTwinRoom')
  }

  // ツアー申込画面のinputから、値をコピーする。
  copyInput() {
    this.copyDate()
    this.copyAirNumber()
    this.copyRoomNumber()
  }

  contact() {
    this.copyInput()
    this.$el.find('#tourContentInformation_form').submit()
  }

  // can access this.el or this.$el
  mounted() {
    this.$el.find('.tourContactInformation_anchor').on('click', (event) => {
      this.contact()
      event.preventDefault()
    })
  }
}

// export as singleton
const instance = new TourContactInformation("#tourContactInformation")
// Object.seal(instance)
export default instance
